import React from 'react';
import { CustomProvider, renderComponent } from "react/utils/renderUtils";
import DataImportSftp from "react/components/DataImportSftp";

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.HTTP = (function () {

    function HTTP() {

        this.type = 'HTTP';

        Greenmile.DataImport.Scheduler.apply(this, arguments);



        this.render = function () {
            const rootClassName = "sftp";

            this.rootEl.className = rootClassName;

            this.clearAndAppendRootEl(rootClassName);

            document.querySelector('#DataImport .generic-modal-portal')?.remove();

            renderComponent(
                <CustomProvider>
                  <DataImportSftp />
                </CustomProvider>,
                this.rootEl
            );
        };
    }

    return HTTP;
}());
